<template>
   <section class="profile-hero">
      <div class="hero-wrapper">
         <LazyAvatar hero />
         <div class="name">
            <h2>{{ profileMeta?.name }}</h2>
            <Btn
               v-bind="{
                  text: 'Edit Profile',
                  url: {
                     name: 'profile-settings-general',
                  },
                  textLink: true,
               }"
               icon
               ><IconEdit class="fill"
            /></Btn>
         </div>

         <div v-if="metaBar?.length" class="meta">
            <div
               v-for="(metaItem, i) in metaBar"
               class="meta-item"
               :key="`${metaItem}-${i}`"
            >
               <p class="label meta-label">{{ metaItem.label }}</p>
               <p class="meta-info">{{ metaItem.value }}</p>
            </div>
         </div>
      </div>
      <div class="stats-wrapper">
         <div v-for="stat in stats" class="stat" :key="`${stat.label}`">
            <p class="stat-num xlarge">{{ stat.value }}</p>
            <p class="label">{{ stat.label }}</p>
         </div>
      </div>
   </section>
</template>

<script setup lang="ts">
import IconEdit from "~/assets/images/icons/alt-edit-filled.svg";
const { profileMeta } = useProfile();

const metaBar = computed(() => {
   const meta = profileMeta.value;
   const memberSinceRaw =
      meta && "member_since" in meta ? meta.member_since : null;
   const memberSince = memberSinceRaw ? new Date(memberSinceRaw) : null;
   const memberSinceOpts: Intl.DateTimeFormatOptions = {
      month: "long",
      day: "numeric",
      year: "numeric",
   };
   return [
      { label: "School", value: meta && "school" in meta ? meta.school?.name : undefined },
      { label: "Title", value: meta && "title" in meta ? meta.title : undefined },
      { label: "Region", value: meta && "school" in meta ? meta.school?.region : undefined },
      {
         label: "Member Since",
         value: memberSince
            ? memberSince.toLocaleDateString(undefined, memberSinceOpts)
            : undefined,
      },
   ];
});

const stats = computed(() => {
   const meta = profileMeta.value;
   const s = meta && "stats" in meta ? meta.stats : undefined;
   return [
      { label: "Completed Lesson Plans", value: s?.completed_teachables },
      { label: "Saved Lesson Plans", value: s?.saved_teachables },
      { label: "Classes Created", value: s?.classes_created },
      { label: "PD Hours Completed", value: s?.hrs_pd_completed },
   ];
});
</script>

<style lang="scss">
@import "~/assets/scss/profile/profile-hero";
</style>
